import { useEffect } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Pricing } from "@/components/landing/Pricing";
import { RoiCalculator } from "@/components/landing/RoiCalculator";
import { FAQ } from "@/components/landing/FAQ";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { Reveal } from "@/components/landing/Reveal";

export default function PricingPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen bg-bone" data-testid="pricing-page">
      <Navbar />
      <main className="pt-28 md:pt-32">
        <section className="mx-auto max-w-[1200px] px-5 sm:px-8 pb-4">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.2em] text-coral mb-4">Plans</p>
            <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.98] tracking-tight text-ink max-w-4xl">
              Simple seat-based pricing. <span className="italic text-coral">No per-listing fees.</span>
            </h1>
            <p className="mt-6 max-w-2xl text-base md:text-lg text-ink/65 leading-relaxed">
              Pick the size of your team, keep every feature. Start free — no credit card.
            </p>
          </Reveal>
        </section>

        <Pricing />
        <RoiCalculator />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
